const pad = (n: number) => String(n).padStart(2, '0');

const toDateTimeLocal = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export const nowDateTimeLocal = (): string => toDateTimeLocal(new Date());

export const tomorrowDateTimeLocal = (): string => toDateTimeLocal(new Date(Date.now() + 24 * 60 * 60 * 1000));

export const tomorrowDate = (): string => tomorrowDateTimeLocal().slice(0, 10);

export const todayDate = (): string => toDateTimeLocal(new Date()).slice(0, 10);

export const withDefaultTime = (value: unknown, endOfDay = false): string => {
  if (typeof value !== 'string' || value.length < 10) return '';
  return value.includes('T') ? value.slice(0, 16) : `${value.slice(0, 10)}T${endOfDay ? '23:59' : '00:00'}`;
};
